import { MouseEvent, forwardRef } from 'react';

import { ListItemInput, ListItemInputProps } from './ListItemInput';
import { Radio, RadioProps } from '../radio/Radio';

export interface ListItemRadioProps extends Omit<ListItemInputProps, 'ref'> {
  /**
   * Callback function for when the ListItemInput is clicked.
   */
  handleClick?: (id: string) => void;
  /**
   * Props for the underlying input (checkbox, radio, switch)
   */
  inputProps?: RadioProps;
  /**
   * Ref for the underlying input
   */
  ref?: React.ForwardedRef<HTMLButtonElement>;
}

export const ListItemRadio = forwardRef<HTMLButtonElement, ListItemRadioProps>(
  ({ classNames = [], inputProps, ...props }: ListItemRadioProps, ref: ListItemRadioProps['ref']) => {
    const { ref: inputRef, ...otherProps } = props;

    function handleChange(e: MouseEvent<HTMLButtonElement>) {
      e.preventDefault();
      otherProps.handleClick(e.currentTarget?.id);
    }

    return (
      <ListItemInput {...otherProps} classNames={classNames}>
        <Radio
          ref={ref}
          id={otherProps.id}
          checked={props.isSelected}
          onClick={handleChange}
          value={otherProps.id}
          {...inputProps}
        />
      </ListItemInput>
    );
  },
);
ListItemRadio.displayName = 'ListItemRadio';
